import React from 'react';
import { observer } from "mobx-react";
import moment from 'moment'

import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import FigureCaption from '../components/FigureCaption';

import {countyAqiPercentagesStore, stateAqiPercentagesStore} from '../store/apiStores'
import {regionAqiPercentagesStore} from '../store/apiStores'


function createChartData(data, days, raw_data) {
    let chartData = {
        'name': 'Population AQI',
        'data': []
    };

    if (data) {
        if (raw_data) {
            chartData = createChartData_rawdata(data, days)
            return chartData
        };
        let seriesData = {};
        data.forEach(function(v){
            let datetime = parseInt(moment.utc(v.local_date).format('x'))
            if (!seriesData['Unmonitored']) {
                seriesData['Unmonitored'] = {name: 'Not Monitored', color: '#CCCCCC', data: []}
            }
            seriesData['Unmonitored']['data'].push([datetime, (100 - (v.pct_good + v.pct_moderate + v.pct_usg + v.pct_unhealthy + v.pct_very_unhealthy + v.pct_hazardous))])
            if (!seriesData['Good']) {
                seriesData['Good'] = {name: 'Good', color: '#71FF71', data: []}
            }
            seriesData['Good']['data'].push([datetime, v.pct_good])
            if (!seriesData['Moderate']) {
                seriesData['Moderate'] = {name: 'Moderate', color: '#FFFF9D', data: []}
            }
            seriesData['Moderate']['data'].push([datetime, v.pct_moderate])
            if (!seriesData['USG']) {
                seriesData['USG'] = {name: 'USG', color: '#FFCE9D', data: []}
            }
            seriesData['USG']['data'].push([datetime, v.pct_usg])
            if (!seriesData['Unhealthy']) {
                seriesData['Unhealthy'] = {name: 'Unhealthy', color: '#FF9393', data: []}
            }
            seriesData['Unhealthy']['data'].push([datetime, v.pct_unhealthy])
            if (!seriesData['Very Unhealthy']) {
                seriesData['Very Unhealthy'] = {name: 'Very Unhealthy', color: '#D19DD7', data: []}
            }
            seriesData['Very Unhealthy']['data'].push([datetime, v.pct_very_unhealthy])
            if (!seriesData['Hazardous']) {
                seriesData['Hazardous'] = {name: 'Hazardous', color: '#B00031', data: []}
            }
            seriesData['Hazardous']['data'].push([datetime, v.pct_hazardous])
        });
        chartData['data'] = Object.values(seriesData);
        if (days) {
            Object.values(chartData.data).forEach(function(v){
                v.data.sort()
                v.data.splice(0, (v.data.length - days))
            });
        };
        if (data[0]) {
            chartData['population'] = data[0].population
        }
    }
    return chartData;
}

function createChartData_rawdata(data, days) {
    let chartData = {
        'name': 'Population AQI',
        'data': []
    };
    let seriesData = {};
    data.forEach(function(v){
        let datetime = parseInt(moment.utc(v.local_date).format('x'))
        if (!seriesData['Unmonitored']) {
            seriesData['Unmonitored'] = {name: 'Not Monitored', color: '#CCCCCC', data: []}
        }
        seriesData['Unmonitored']['data'].push([datetime, ((100 - (v.pct_good + v.pct_moderate + v.pct_usg + v.pct_unhealthy + v.pct_very_unhealthy + v.pct_hazardous))/100)*v.population])
        if (!seriesData['Good']) {
            seriesData['Good'] = {name: 'Good', color: '#71FF71', data: []}
        }
        seriesData['Good']['data'].push([datetime, (v.pct_good/100)*v.population])
        if (!seriesData['Moderate']) {
            seriesData['Moderate'] = {name: 'Moderate', color: '#FFFF9D', data: []}
        }
        seriesData['Moderate']['data'].push([datetime, (v.pct_moderate/100)*v.population])
        if (!seriesData['USG']) {
            seriesData['USG'] = {name: 'USG', color: '#FFCE9D', data: []}
        }
        seriesData['USG']['data'].push([datetime, (v.pct_usg/100)*v.population])
        if (!seriesData['Unhealthy']) {
            seriesData['Unhealthy'] = {name: 'Unhealthy', color: '#FF9393', data: []}
        }
        seriesData['Unhealthy']['data'].push([datetime, (v.pct_unhealthy/100)*v.population])
        if (!seriesData['Very Unhealthy']) {
            seriesData['Very Unhealthy'] = {name: 'Very Unhealthy', color: '#D19DD7', data: []}
        }
        seriesData['Very Unhealthy']['data'].push([datetime, (v.pct_very_unhealthy/100)*v.population])
        if (!seriesData['Hazardous']) {
            seriesData['Hazardous'] = {name: 'Hazardous', color: '#B00031', data: []}
        }
        seriesData['Hazardous']['data'].push([datetime, (v.pct_hazardous/100)*v.population])
    });
    chartData['data'] = Object.values(seriesData);
    if (days) {
        Object.values(chartData.data).forEach(function(v){
            v.data.sort()
            v.data.splice(0, (v.data.length - days))
        });
    };
    if (data[0]){
        chartData['population'] = data[0].population
    }
    return chartData;
}

function createChartOptions(props) {
    let customOptions = {};
    if (props.raw_data){
        customOptions['tooltips_label'] = '<span style="color:{series.color}">{series.name}</span>: <b>{point.y:,.0f}</b><br/>'
    } else {
        customOptions['tooltips_label'] = '<span style="color:{series.color}">{series.name}</span>: <b>{point.y:.1f}%</b><br/>'
    }
    if (props.gauge) {
        customOptions['title_text'] = null
        customOptions['subtitle_text'] = null
        customOptions['height'] = 100
        customOptions['width'] = 100
        customOptions['tooltip'] = false
        customOptions['labels'] = false
        customOptions['ticks'] = 0
        customOptions['hover'] = false
        customOptions['marker'] = false
        customOptions['legend'] = false
    } else {
        if (props.state) {
            customOptions['title_text'] = `${props.state} Air Quality`
            if (props.raw_data){
                customOptions['subtitle_text'] = 'state population living within each AQI level'
            } else {
                customOptions['subtitle_text'] = '% of state population living within each AQI level'
            }
        } else if (props.region){
            customOptions['title_text'] = `${props.region} Air Quality`
            if (props.raw_data){
                customOptions['subtitle_text'] = 'region population living within each AQI level'
            } else {
                customOptions['subtitle_text'] = '% of region population living within each AQI level'
            }
        } else {
            customOptions['title_text'] = `${props.county} County Air Quality`
            if (props.raw_data){
                customOptions['subtitle_text'] = 'county population living within each AQI level'
            } else {
                customOptions['subtitle_text'] = '% of county population living within each AQI level'
            }
        }
        customOptions['width'] = null
        customOptions['height'] = null
        customOptions['tooltip'] = true
        customOptions['labels'] = true
        customOptions['ticks'] = 4
        customOptions['hover'] = true
        customOptions['marker'] = false
        customOptions['legend'] = true
    }
    return customOptions;
}

function thirtydaysago(data) {
    if (!data || data.length == 0 || !data[0].data || data[0].data.length == 0) {
        // data hasn't loaded yet
        return null;
    }
    let last_dates = []
    data.forEach(function(v){
        v.data.sort()
        last_dates.push(v.data[v.data.length - 1][0])
    });
    let last_day = Math.max(...last_dates)
    return(last_day - ((24*60*60*1000) * 30))
}

export default observer(function StatecountyAQIAreachart(props) {
    let chartData = {data:[]};
    let customOptions = createChartOptions(props);
    let days = false;
    if (props.days) {
        days = props.days
    };
    if (props.gauge || props.state){
        chartData = createChartData(stateAqiPercentagesStore.data, days, props.raw_data);
    } else if (props.region) {
        chartData = createChartData(regionAqiPercentagesStore.data, days, props.raw_data);
    } else {
        chartData = createChartData(countyAqiPercentagesStore.data, days, props.raw_data);
    }
    let ymax = 100;
    if (props.raw_data){
        ymax = chartData.population
    };

    let options = {
        chart: {
            type: 'area',
            height: customOptions.height,
            width: customOptions.width,
            zoomType: 'x',
            animation: false
        },

        credits: {
            enabled: false
        },

        title: {
            text: customOptions.title_text,
            align: 'left'
        },

        subtitle: {
            text: customOptions.subtitle_text,
            align: 'left'
        },

        yAxis: {
            min: 0,
            max: ymax,
            endOnTick: false,
            labels: {
                enabled: customOptions.labels,
                formatter: function () {
                    if (props.raw_data){
                        return  Highcharts.numberFormat(this.value, 0, '', ',')
                    } else {
                        return this.value + '%'
                    }
                }
            },
            title: {
                enabled: false
            },
            opposite: true
        },

        xAxis: {
            type: 'datetime',
            labels: {
                enabled: customOptions.labels
            },
            tickLength: customOptions.ticks,
            dateTimeLabelFormats: {
                month: '%e. %b',
                year: '%b'
            }
        },

        tooltip: {
            enabled: customOptions.tooltip,
            pointFormat: customOptions.tooltips_label,
            split: true
        },

        legend: {
            enabled: customOptions.legend,
            align: 'center',
            verticalAlign: 'bottom',
            x: 0,
            y: 0
        },

        plotOptions: {
            area: {
                stacking: 'normal',
                lineColor: '#ffffff',
                lineWidth: 1,
                marker: {
                    lineColor: '#ffffff'
                }
            },
            series: {
                marker: {
                    enabled: customOptions.marker,
                    symbol: 'circle'
                },
                dataLabels: {
                    enabled: false
                },
                states: {
                    hover: {
                        enabled: customOptions.hover
                    },
                    inactive: {
                        opacity: 1
                    }
                },
                animation: false
            }
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    xAxis: {
                        max: null,
                        min: thirtydaysago(chartData.data)
                    }
                }
            }]
        },

        series: chartData.data
    }

    if (chartData.data.length > 0) {
        return (
            <div>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options} />
                {!props.gauge && (
                <FigureCaption short_caption={'Population in each AQI category'} caption={'Population living in each Air Quality Index category (based on PM2.5 levels only). As percent population or total population. Aggregated from an analysis of permanent PM2.5 monitoring sites that are closest to a mapped population grid (Larkin et al, in prep). Only population within 20km of a monitor is evaluated; the rest is considered as unmonitored and shown in grey.'} />
                )}
                <br />
            </div>
        )
    } else {
        return null
    }
})
